// Add new NAICS codes for Arts, Entertainment, and Recreation
const ARTS_ENTERTAINMENT_CODES = [
  {
    code: '711110',
    title: 'Theater Companies and Dinner Theaters',
    description: 'Establishments primarily engaged in producing live theatrical productions',
    sector: 'Arts, Entertainment, and Recreation'
  },
  {
    code: '711120',
    title: 'Dance Companies',
    description: 'Establishments primarily engaged in producing dance performances',
    sector: 'Arts, Entertainment, and Recreation'
  },
  {
    code: '711130',
    title: 'Musical Groups and Artists',
    description: 'Establishments primarily engaged in producing live musical entertainment',
    sector: 'Arts, Entertainment, and Recreation'
  }
];

// Add new NAICS codes for Accommodation and Food Services
const ACCOMMODATION_FOOD_CODES = [
  {
    code: '721110',
    title: 'Hotels and Motels',
    description: 'Establishments primarily engaged in providing short-term lodging',
    sector: 'Accommodation and Food Services'
  },
  {
    code: '722511',
    title: 'Full-Service Restaurants',
    description: 'Establishments primarily engaged in providing food services to patrons',
    sector: 'Accommodation and Food Services'
  },
  {
    code: '722320',
    title: 'Caterers',
    description: 'Establishments primarily engaged in providing food services at remote locations',
    sector: 'Accommodation and Food Services'
  }
];

// Combine with existing NAICS codes
export const FULL_NAICS_CODES = [
  ...ARTS_ENTERTAINMENT_CODES,
  ...ACCOMMODATION_FOOD_CODES,
  // Printing and Related Services
  {
    code: '323111',
    title: 'Commercial Printing (except Screen and Books)',
    description: 'Commercial printing using various processes except screen printing and books'
  },
  {
    code: '323113',
    title: 'Commercial Screen Printing',
    description: 'Commercial screen printing on any material'
  },
  {
    code: '323117',
    title: 'Books Printing',
    description: 'Printing books and pamphlets'
  },
  {
    code: '323120',
    title: 'Support Activities for Printing',
    description: 'Providing support services for printing industries'
  },
  // Staffing Services
  {
    code: '561311',
    title: 'Employment Placement Agencies',
    description: 'Listing employment vacancies and placing applicants'
  },
  {
    code: '561312',
    title: 'Executive Search Services',
    description: 'Providing executive search and placement services'
  },
  {
    code: '561320',
    title: 'Temporary Help Services',
    description: 'Supplying workers for limited periods'
  },
  {
    code: '561330',
    title: 'Professional Employer Organizations',
    description: 'Providing human resources and management services'
  },
  // Office Supplies and Related Services
  {
    code: '424120',
    title: 'Stationery and Office Supplies Merchant Wholesalers',
    description: 'Wholesaling stationery and office supplies'
  },
  {
    code: '453210',
    title: 'Office Supplies and Stationery Stores',
    description: 'Retailing office supplies and stationery'
  },
  {
    code: '532420',
    title: 'Office Machinery and Equipment Rental and Leasing',
    description: 'Renting and leasing office equipment'
  },
  {
    code: '561110',
    title: 'Office Administrative Services',
    description: 'Providing office administrative services'
  },
  // Software and Computer Services
  {
    code: '511210',
    title: 'Software Publishers',
    description: 'Publishing and distributing software'
  },
  {
    code: '518210',
    title: 'Data Processing, Hosting, and Related Services',
    description: 'Providing data processing and hosting services'
  },
  {
    code: '541511',
    title: 'Custom Computer Programming Services',
    description: 'Writing, modifying, testing, and supporting software'
  },
  {
    code: '541512',
    title: 'Computer Systems Design Services',
    description: 'Planning and designing computer systems'
  },
  {
    code: '541513',
    title: 'Computer Facilities Management Services',
    description: 'Managing computer and data processing facilities'
  },
  {
    code: '541519',
    title: 'Other Computer Related Services',
    description: 'Providing other computer-related services'
  },
  // Automotive Related
  {
    code: '441110',
    title: 'New Car Dealers',
    description: 'Retailing new automobiles and light trucks'
  },
  {
    code: '441120',
    title: 'Used Car Dealers',
    description: 'Retailing used automobiles and light trucks'
  },
  {
    code: '441310',
    title: 'Automotive Parts and Accessories Stores',
    description: 'Retailing automotive parts and accessories'
  },
  {
    code: '441320',
    title: 'Tire Dealers',
    description: 'Retailing automotive tires'
  },
  {
    code: '811111',
    title: 'General Automotive Repair',
    description: 'Providing general automotive repair services'
  },
  {
    code: '811112',
    title: 'Automotive Exhaust System Repair',
    description: 'Repairing automotive exhaust systems'
  },
  {
    code: '811113',
    title: 'Automotive Transmission Repair',
    description: 'Repairing automotive transmissions'
  },
  {
    code: '811118',
    title: 'Other Automotive Mechanical and Electrical Repair and Maintenance',
    description: 'Providing other automotive repair services'
  },
  {
    code: '811121',
    title: 'Automotive Body, Paint, and Interior Repair and Maintenance',
    description: 'Repairing automotive bodies and interiors'
  },
  {
    code: '811122',
    title: 'Automotive Glass Replacement Shops',
    description: 'Replacing automotive glass'
  },
  // Procurement Related
  {
    code: '423430',
    title: 'Computer and Computer Peripheral Equipment and Software Merchant Wholesalers',
    description: 'Wholesaling computers and software'
  },
  {
    code: '423120',
    title: 'Motor Vehicle Supplies and New Parts Merchant Wholesalers',
    description: 'Wholesaling motor vehicle supplies'
  },
  {
    code: '423710',
    title: 'Hardware Merchant Wholesalers',
    description: 'Wholesaling hardware'
  },
  {
    code: '423830',
    title: 'Industrial Machinery and Equipment Merchant Wholesalers',
    description: 'Wholesaling industrial machinery'
  },
  {
    code: '423840',
    title: 'Industrial Supplies Merchant Wholesalers',
    description: 'Wholesaling industrial supplies'
  }
];